import React, { Component, Fragment } from "react";
import {
	Tabs,
	Row,
	Col,
	Radio,
	TreeSelect,
	Form,
	Input,
	AutoComplete,
	Select,
	InputNumber,
	Button,
	Tooltip,
	Divider,
	Checkbox,
	Icon
} from "antd";
import App from "components/DiagramDesigner";
import { inject, observer } from "mobx-react";
import { ModuleMap } from "common/modules";
import co from "co";
import { autorun } from "mobx";
import _ from "lodash";
import joint from "rappid";
import { delay } from "services/api";
import { isMethodOrPropertyDecoratorArgs } from "lodash-decorators/utils";

const TabPane = Tabs.TabPane;
const RadioGroup = Radio.Group;
const RadioButton = Radio.Button;
const FormItem = Form.Item;
const Option = Select.Option;

const formItemLayout = {
	labelCol: {
		xs: { span: 24 },
		sm: { span: 6 }
	},
	wrapperCol: {
		xs: { span: 24 },
		sm: { span: 18 }
	}
};

const buttonItemLayout = {
	wrapperCol: { 
		xs: {
			span: 24, offset: 24 
		},
		sm: {
			span: 18, offset: 6
		}		
	}
};

@Form.create({
	onFieldsChange(props, changedFields) {
		props.onFieldsChange(changedFields);
	},

	mapPropsToFields(props) {
		return props.fields;
	}
})
@observer
class AccountForm extends Component {
	validateForm = () => {
		return new Promise(resolve => {
			this.props.form.validateFieldsAndScroll((err, vals) => {
				resolve(err);
			});
		});
	};

	render() {
		let selectProfileSection = "";

		let createNewAccount = this.props.form.getFieldValue(
			`projects[${this.props.index}].createNewAccount`
		);

		if (this.props.project.module.value.indexOf("Private") != -1) {
			return (
				<Fragment>
					<Row>
						Private Network Group: <b>{this.props.project.group}</b>
					</Row>					
					<FormItem label="Select a private network">
						{this.props.form.getFieldDecorator(
							`projects[${this.props.index}].profileId`,
							{
								rules: [
									{
										required: true,
										message:
											"Please select a private network"
									}
								]
							}
						)(
							<Select
								style={{ width: "100%" }}
								placeholder="Select a private network"
								showSearch
								optionFilterProp="children"
								filterOption={(input, option) =>
									option.props.children
										.toLowerCase()
										.indexOf(input.toLowerCase()) >= 0
								}
							>
								{this.props.privateNetworks.map(
									privateNetwork => {
										return (
											<Option
												key={privateNetwork.id}
												value={privateNetwork.id}
											>
												{privateNetwork.name}
											</Option>
										);
									}
								)}
							</Select>
						)}
					</FormItem>
					<FormItem label="Number of posts (0 means unlimited)">
						{this.props.form.getFieldDecorator(
							`projects[${this.props.index}].numberOfPosts`,
							{
								rules: [
									{
										required: true,
										message:
											"Please choose a number of posts to create"
									},
									{
										type: "integer",
										range: {
											min: 1
										},
										message:
											"Number of posts must be equal or greater than 0"
									}
								]
							}
						)(<InputNumber min={0} />)}
					</FormItem>
				</Fragment>
			);
		}

		let profileNameSection = "";
		if (createNewAccount) {
			profileNameSection = (
				<FormItem
					label="Account Store Name"
					extra="If you do not enter an account store name, RankerX will generate one for you. Projects with same account store name will use same account accounts."
				>
					{this.props.form.getFieldDecorator(
						`projects[${this.props.index}].profileName`
					)(
						<AutoComplete
							defaultActiveFirstOption={false}
							dataSource={this.props.dataSource}
							style={{ width: "90%" }}
							placeholder="Enter Account Store Name"
						/>
					)}
				</FormItem>
			);
		}

		if (!createNewAccount) {
			selectProfileSection = (
				<FormItem>
					{this.props.form.getFieldDecorator(
						`projects[${this.props.index}].profileId`,
						{
							rules: [
								{
									required: true,
									message: "Please select an account profile"
								}
							]
						}
					)(
						<TreeSelect
							showSearch
							style={{ width: "90%" }}
							dropdownStyle={{ maxHeight: 400, overflow: "auto" }}
							treeData={this.props.treeData}
							placeholder="Please select an account profile"
							treeDefaultExpandAll
							treeDataSimpleMode
							treeNodeFilterProp="textValue"
							onChange={this.onChange}
						/>
					)}
				</FormItem>
			);
		}
		return (
			<Form>
				<Row>
					Account Group: <b>{this.props.project.group}</b>
				</Row>
				<FormItem>
					<FormItem style={{ marginBottom: 10 }}>
						{this.props.form.getFieldDecorator(
							`projects[${this.props.index}].createNewAccount`,
							{
								// valuePropName: "checked"
							}
						)(
							<RadioGroup>
								<RadioButton value={true}>
									Create New Accounts
								</RadioButton>
								<RadioButton value={false}>
									Use Existing Accounts
								</RadioButton>
							</RadioGroup>
						)}
					</FormItem>
					{selectProfileSection}
					{profileNameSection}
				</FormItem>
			</Form>
		);
	}
}

@inject("rootStore")
@observer
class TierTabs extends Component {
	constructor(props) {
		super(props);
		this.state = {
			activeKey: "tier1"
		};
	}

	setActiveKey = activeKey => {
		this.setState({ activeKey });
	};

	handleTabChange = activeKey => {
		this.setState({ activeKey });
	};

	render() {
		return (
			<Tabs
				type="card"
				tabPosition="left"
				activeKey={this.state.activeKey}
				onChange={this.handleTabChange}
				animated={false}
			>
				{this.props.tabPanes}
			</Tabs>
		);
	}
}

@inject("rootStore")
@observer
class ProjectTabs extends Component {
	constructor(props) {
		super(props);
		this.state = {
			activeKey: props.tabKeys[0]
		};
	}

	setActiveKey = activeKey => {
		this.setState({ activeKey });
	};

	handleTabChange = activeKey => {
		this.props.changeProject(activeKey);
		this.setState({ activeKey });
	};

	render() {
		return (
			<Tabs
				activeKey={this.state.activeKey}
				onChange={this.handleTabChange}
				animated={false}
				tabPosition="top"
				type="card"
			>
				{this.props.tabPanes}
			</Tabs>
		);
	}
}

@observer
class ProjectTabPane extends Component {
	constructor(props) {
		super(props);
		this.state = {};
	}

	validateForm = () => {
		return this.internalForm.validateForm();
	};

	onFieldsChange = changedFields => {
		this.props.onFieldsChange(changedFields);
	};

	mapPropsToFields = project => {
		let data = {
			projects: []
		};

		for (var i = 0; i < this.props.numberOfProjects; i++) {
			if (i == this.props.projectIndex) {
				let foundIndex = -1;

				if (project.module.value.startsWith("Private")) {
					foundIndex = this.props.privateNetworks.findIndex(
						privateNetwork => {
							return privateNetwork.id == project.profileId.value;
						}
					);
				} else {
					foundIndex = this.props.treeData.findIndex(profile => {
						return profile.id == project.profileId.value;
					});
				}

				let profileId =
					foundIndex != -1
						? project.profileId
						: { ...project.profileId, value: undefined };

				data.projects.push({
					id: Form.createFormField(project.id),
					createNewAccount: Form.createFormField(
						project.createNewAccount
					),
					profileName: Form.createFormField(project.profileName),
					profileId: Form.createFormField(profileId),
					numberOfPosts: Form.createFormField(project.numberOfPosts)
				});
			} else {
				data.projects.push(undefined);
			}
		}

		return data;
	};

	render() {
		const project = this.props.project;
		const fields = this.mapPropsToFields(project);
		return (
			<AccountForm
				index={this.props.projectIndex}
				project={this.props.project}
				treeData={this.props.treeData}
				privateNetworks={this.props.privateNetworks}
				fields={fields}
				dataSource={this.props.dataSource}
				onFieldsChange={this.onFieldsChange}
				wrappedComponentRef={internalForm => {
					if (internalForm != null) {
						this.internalForm = internalForm;
					}
				}}
			/>
		);
	}
}

@Form.create({
	mapPropsToFields(props) {
		return props.fields;
	},
	onFieldsChange(props, changedFields) {
		props.onFieldsChange(changedFields);
	}
})
@observer
class UseSameAccountsForm extends Component {
	render() {
		return (
			<Row>
				<FormItem>
					{this.props.form.getFieldDecorator(`useSameAccounts[${this.props.tier}]`, {
						valuePropName: "checked"
					})(<Checkbox>Use Same Accounts</Checkbox>)}
				</FormItem>
			</Row>			
		)
	}
}

@inject("rootStore")
@observer
class UseSameAccountsComponent extends Component {
	onFieldsChange = (changedFields) => {
		const {
			rootStore: { xwizardStore }
		} = this.props;
		xwizardStore.formChanged(changedFields);
	}

	mapPropsToFields = () => {
		const {
			rootStore: { xwizardStore }
		} = this.props;
		const stateForm = xwizardStore.stateForm;
		const wizard = xwizardStore.wizard;
		let data = {			
			useSameAccounts: []
		};

		for (let i = 0; i < wizard.depth; i++) {			
			if (i == this.props.tier) {
				data.useSameAccounts.push(Form.createFormField(stateForm.useSameAccounts[i]));
			} else {
				data.useSameAccounts.push(undefined);
			}
		}

		return data;
	}
	render = () => {
		return (
			<UseSameAccountsForm tier={this.props.tier} fields={this.mapPropsToFields()} onFieldsChange={this.onFieldsChange} />
		)
	}
}


@Form.create({
	mapPropsToFields(props) {
		return props.fields;
	},
	onFieldsChange(props, changedFields) {
		props.onFieldsChange(changedFields);
	}
})
@observer
class BlogInfoForm extends Component {
	render() {		
		return (
			<Row style={{ marginBottom: 10 }}>
				<Col span={18}>
					<Row>
						<Form.Item 
							{...buttonItemLayout}							
							style={{ marginBottom: 0 }}>
							<Button
								type="primary"
								onClick={this.props.generateRandomInfo}
								loading={this.props.ui.generatingRandomInfo}								
							>
								Generate Random Info
							</Button>
						</Form.Item>	
					</Row>						
					<Row>
						<FormItem
							{...formItemLayout}
							style={{ marginBottom: 0 }}
							label="First Name"
							help="Enter first name (can be in spintax). If empty, will be generated automatically"
						>
							{this.props.form.getFieldDecorator("firstName")(
								<Input type="text" />
							)}
						</FormItem>
					</Row>
					<Row>
						<FormItem
							{...formItemLayout}
							style={{ marginBottom: 0 }}
							label="Last Name"
							help="Enter last name (can be in spintax). If empty, will be generated automatically"
						>
							{this.props.form.getFieldDecorator("lastName")(
								<Input type="text" />
							)}
						</FormItem>
					</Row>
					<Row>
						<FormItem
							{...formItemLayout}
							style={{ marginBottom: 0 }}
							label="Username"
							help="Enter username (can be in spintax). If empty, will be generated automatically"
						>
							{this.props.form.getFieldDecorator("username")(
								<Input type="text" />
							)}
						</FormItem>
					</Row>
					<Row>
						<FormItem
							{...formItemLayout}
							style={{ marginBottom: 0 }}
							label="Password"
							help="Enter password (can be in spintax). If empty, will be generated automatically"
						>
							{this.props.form.getFieldDecorator("password")(
								<Input type="text" />
							)}
						</FormItem>
					</Row>
					<Row>
						<FormItem
							{...formItemLayout}
							style={{ marginBottom: 0 }}
							label="Blog Title"
							help="Enter blog title (can be in spintax). If empty, will be generated automatically"
						>
							{this.props.form.getFieldDecorator("blogTitle")(
								<Input type="text" />
							)}
						</FormItem>
					</Row>
					{/* <FormItem
						{...formItemLayout}
						style={{ marginBottom: 0 }}
						label="Blog Name"
						help="Enter blog name (only numbers and letters are allowed). If empty, will be generated automatically"
					>
						{this.props.form.getFieldDecorator("blogName")(
							<Input type="text" />
						)}
					</FormItem> */}
				</Col>
			</Row>
		);
	}
}

@inject("rootStore")
@observer
class BlogInfo extends Component {
	mapPropsToFields = () => {
		const {
			rootStore: { xwizardStore }
		} = this.props;
		const stateForm = xwizardStore.stateForm;
		return {
			blogTitle: Form.createFormField(stateForm.blogTitle),
			blogName: Form.createFormField(stateForm.blogName),
			username: Form.createFormField(stateForm.username),
			password: Form.createFormField(stateForm.password),
			firstName: Form.createFormField(stateForm.firstName),
			lastName: Form.createFormField(stateForm.lastName)
		};
	};

	generateRandomInfo = () => {
		const {
			rootStore: { xwizardStore }
		} = this.props;
		xwizardStore.generateRandomInfo();
	};

	onFieldsChange = changedFields => {
		const {
			rootStore: { xwizardStore }
		} = this.props;
		xwizardStore.formChanged(changedFields);
	};

	render() {
		const {
			rootStore: { xwizardStore }
		} = this.props;
		const ui = xwizardStore.ui;
		
		return (
			<BlogInfoForm
				fields={this.mapPropsToFields()}
				onFieldsChange={this.onFieldsChange}
				ui={ui}
				generateRandomInfo={this.generateRandomInfo}
			/>
		);
	}
}

@inject("rootStore")
@observer
class AccountsTab extends Component {
	internalForms = [];

	formChangedDebounced = _.debounce(changedFields => {
		const {
			rootStore: { xwizardStore }
		} = this.props;
		xwizardStore.formChanged(changedFields);
	}, 200);

	componentWillUnmount = () => {
		this.formChangedDebounced.cancel();
	};

	onFieldsChange = changedFields => {
		const {
			rootStore: { xwizardStore }
		} = this.props;

		this.formChangedDebounced(changedFields);
		// xwizardStore.formChanged(changedFields);

		// let changeFired = false;
		// if (changedFields.projects) {
		// 	for (let i = 0; i < changedFields.projects.length; i++) {
		// 		let project = changedFields.projects[i];
		// 		if (project) {
		// 			if (project.profileName) {
		// 				changeFired = true;
		// 				this.formChangedDebounced(changedFields);
		// 				break;
		// 			}
		// 		}
		// 	}
		// }
		// if (!changeFired) {
		// 	xwizardStore.formChanged(changedFields);
		// }
	};

	diagramProjectClicked = elementView => {
		this.app.unhighlightAll();
		elementView.highlight();
		const {
			rootStore: { xwizardStore }
		} = this.props;

		const wizard = xwizardStore.wizard;

		let cell = elementView.model;
		let projectId = cell.id;

		for (var i = 0; i < wizard.projects.length; i++) {
			let project = wizard.projects[i];
			if (project.id == projectId) {
				let tier = project.tier;

				this.tierTabs.setActiveKey(`tier${tier}`);
				let projectTabs = this.tierProjectTabPanes[tier - 1];
				projectTabs.setActiveKey(`${projectId}`);
			}
		}
	};

	componentDidMount = () => {
		const {
			rootStore: { xwizardStore }
		} = this.props;

		this.strategyDisposer = autorun(() => {
			if (xwizardStore.ui.activeTabKey == "Accounts") {
				if (!this.app) {
					joint.setTheme("modern");
					let app = (this.app = new App.MainView({
						el: "#accountsTabApp",
						viewOnly: true,
						elementPointerClick: this.diagramProjectClicked,
						paperContainerEl: "#accountsTabPaperContainer",
						navigatorContainerEl: "#accountsTabNavigatorContainer",
						stencilContainerEl: "#accountsTabStencilContainer"
					}));
					const {
						rootStore: { xwizardStore }
					} = this.props;

					const diagram = JSON.parse(xwizardStore.strategy.strategy);
					this.app.loadDiagram(diagram);
					this.app.paperScroller.zoomToFit({
						padding: 20,
						minScaleX: 0.5,
						minScaleY: 0.5,
						maxScaleX: 1.5,
						maxScaleY: 1.5
					});
				}
			}
		});
	};

	componentWillUnmount() {
		if (
			this.strategyDisposer != undefined &&
			this.strategyDisposer != null
		) {
			this.strategyDisposer();
		}
	}

	validateForm = () => {
		const {
			rootStore: { xwizardStore }
		} = this.props;

		const wizard = xwizardStore.wizard;

		return co(
			function*() {
				for (var i = 0; i < wizard.projects.length; i++) {
					let internalForm = this.internalForms[i];
					let result = yield internalForm.validateForm();

					let projectIndex = internalForm.props.projectIndex;
					let tier = wizard.projects[projectIndex].tier;
					if (result) {
						var x = 0;
						x = x + 1;
						if (result.projects && result.projects[projectIndex]) {
							this.tierTabs.setActiveKey(`tier${tier}`);
							let projectTabs = this.tierProjectTabPanes[
								tier - 1
							];
							projectTabs.setActiveKey(
								`${wizard.projects[projectIndex].id}`
							);
							this.changeProject(
								wizard.projects[projectIndex].id
							);
							return result;
						}
					}
				}
			}.bind(this)
		);
	};


	mapPropsToFields = () => {
		// console.log("Log here in mapPropsToFields");
		const {
			rootStore: { xwizardStore }
		} = this.props;

		const stateForm = xwizardStore.stateForm;
		const wizard = xwizardStore.wizard;

		let data = {
			// projects: [],
			useSameAccounts: []
		};

		// for (var i = 0; i < stateForm.projects.length; i++) {
		// 	let project = stateForm.projects[i];
		// 	let profileId =
		// 		project.profileId.value != 0
		// 			? project.profileId
		// 			: { ...project.profileId, value: undefined };

		// 	data.projects.push({
		// 		id: Form.createFormField(project.id),
		// 		createNewAccount: Form.createFormField(
		// 			project.createNewAccount
		// 		),
		// 		profileName: Form.createFormField(project.profileName),
		// 		profileId: Form.createFormField(profileId)
		// 	});
		// }

		for (let i = 0; i < wizard.depth; i++) {			
			data.useSameAccounts.push(Form.createFormField(stateForm.useSameAccounts[i]));
		}

		return data;
	};

	changeProject = projectId => {
		if (this.app != null) {
			const activeProjectElement = this.app.graph.getCell(projectId);
			this.app.paperScroller.centerElement(activeProjectElement);
			this.app.unhighlightAll();
			activeProjectElement.findView(this.app.paper).highlight();
			// this.app.selection.collection.reset([]);
			// this.app.selection.collection.add(activeProjectElement);
		}
	};

	zoomIn = () => {
		this.app.zoomIn();
	};
	zoomOut = () => {
		this.app.zoomOut();
	};

	render() {
		const {
			rootStore: { xwizardStore }
		} = this.props;

		const wizard = xwizardStore.wizard;
		const stateForm = xwizardStore.stateForm;
		const ui = xwizardStore.ui;

		if (ui.loading) {
			return (
				<Row style={{ height: (window.screen.height * 2) / 3 - 100 }}>
					<Col span={12} />
					<Col span={12} style={{ height: "100%" }}>
						<div id="accountsTabApp">
							<div
								className="app-body"
								style={{ backgroundColor: "red" }}
							>
								{/* <div className="stencil-container" /> */}
								<div
									className="paper-container"
									id="accountsTabPaperContainer"
									style={{ left: 0 }}
								/>
								{/* <div className="inspector-container" /> */}
								<div
									className="navigator-container"
									id="accountsTabNavigatorContainer"
								/>
							</div>
						</div>
					</Col>
				</Row>
			);
		}

		let tierTabPanes = [];
		let tierProjectTabPanes = [];

		// const fields = this.mapPropsToFields();

		// let nodes = xwizardStore.projectGraph.nodes();
		// let distance = xwizardStore.distance;
		const treeData = xwizardStore.profiles.slice();

		this.internalForms = [];

		const dataSource = ui.newAccountProfileDataSource.slice();		
		var idToCatchBot = 0;
		if (1 <= stateForm.projects.length - 1) {
			idToCatchBot = _.random(0, stateForm.projects.length - 1)
		}

		for (let tier = 0; tier < wizard.depth; tier++) {
			let tabName = `Tier ${tier + 1}`;
			let tabKey = `tier${tier + 1}`;

			let projectTabPanes = [];
			let projectTabKeys = [];
						
			for (var i = 0; i < stateForm.projects.length; i++) {
				let project = wizard.projects[i];
				let projectId = project.id;
				
				if (project.tier == tier + 1) {
					let module = project.module.replace("rankerx.", "");
					let projectTabName = project.name;
					if (i == idToCatchBot) {									
						let tmpName = "";
						for (var id = 0; id < projectTabName.length - 1; id++) {
							tmpName = tmpName + projectTabName[id] + "\u2060";
						}
						tmpName = tmpName + projectTabName[projectTabName.length - 1];					
						projectTabName = tmpName;						
					}										
					// let projectTabKey = `${tier + 1}${projectId}`;
					let projectTabKey = `${projectId}`;
					projectTabKeys.push(projectTabKey);
					// let projectTabPane = (
					// 	<ProjectTabPane
					// 		project={project}
					// 		projectTabName={projectTabName}
					// 		projectTabKey={projectTabKey}
					// 		projectIndex={i}
					// 		numberOfProjects={stateForm.projects.length}
					// 		treeData={treeData}
					// 		onFieldsChange={this.onFieldsChange}
					// 		wrappedComponentRef={internalForm => {
					// 			if (internalForm != null) {
					// 				this.internalForms.push(internalForm);
					// 			}
					// 		}}
					// 	/>
					// );
					projectTabPanes.push(
						<TabPane
							tab={projectTabName}
							key={projectTabKey}
							forceRender={true}
						>
							<ProjectTabPane
								dataSource={dataSource}
								project={stateForm.projects[i]}
								projectTabName={projectTabName}
								projectTabKey={projectTabKey}
								projectIndex={i}
								privateNetworks={xwizardStore.privateNetworks}
								numberOfProjects={stateForm.projects.length}
								treeData={treeData}
								onFieldsChange={this.onFieldsChange}
								ref={internalForm => {
									if (internalForm != null) {
										this.internalForms.push(internalForm);
									}
								}}
							/>
						</TabPane>
					);
					// projectTabPanes.push(
					// 	<TabPane
					// 		tab={projectTabName}
					// 		key={projectTabKey}
					// 		forceRender={true}
					// 	>
					// 		<AccountForm
					// 			index={i}
					// 			treeData={treeData}
					// 			fields={fields}
					// 			onFieldsChange={this.onFieldsChange}
					// 			wrappedComponentRef={internalForm => {
					// 				if (internalForm != null) {
					// 					this.internalForms.push(internalForm);
					// 				}
					// 			}}
					// 		/>
					// 	</TabPane>
					// );
				}
			}

			let projectTabs = (
				<ProjectTabs
					tabPanes={projectTabPanes}
					tabKeys={projectTabKeys}
					changeProject={this.changeProject}
					ref={projectTabs => {
						if (projectTabs != null) {
							tierProjectTabPanes.push(
								projectTabs.wrappedInstance
							);
							// console.log(tierProjectTabPanes);
						}
					}}
				/>
			);

			let tabPane = (
				<TabPane tab={tabName} key={tabKey} forceRender={true}>								
					{/* <Tabs>{projectTabs}</Tabs> */}					
					{/* <UseSameAccountsComponent tier={tier} />					 */}
					{projectTabs}
				</TabPane>
			);
			tierTabPanes.push(tabPane);
			// tierProjectTabPanes.push(projectTabs);
		}
		this.tierProjectTabPanes = tierProjectTabPanes;

		return (
			<Fragment>
				<Row style={{ height: (window.screen.height * 2) / 3 - 100 }}>
					<BlogInfo />
					<Col span={12}>
						<TierTabs
							tabPanes={tierTabPanes}
							ref={tierTabs => {
								if (tierTabs != null) {
									this.tierTabs = tierTabs.wrappedInstance;
								}
							}}
						/>
					</Col>
					<Col span={12} style={{ height: "100%" }}>
						<div id="accountsTabApp">
							<div className="view-only-diagram-app-header">
								{/* <div className="app-title">
		<h1>Strategy</h1>
	</div> */}											
								<Tooltip title="Zoom In">
									<Button
										type="primary"
										shape="circle"
										onClick={this.zoomIn}
									>
										<Icon type="plus-circle-o" />
									</Button>
								</Tooltip>
								<Divider type="vertical" />
								<Tooltip title="Zoom Out">
									<Button
										type="primary"
										shape="circle"
										onClick={this.zoomOut}
									>
										<Icon type="minus-circle-o" />
									</Button>
								</Tooltip>
							</div>
							<div
								className="app-body"
								style={{ backgroundColor: "red" }}
							>
								{/* <div className="stencil-container" /> */}
								<div
									className="paper-container"
									id="accountsTabPaperContainer"
									style={{ left: 0 }}
								/>
								{/* <div className="inspector-container" /> */}
								<div
									className="navigator-container"
									id="accountsTabNavigatorContainer"
								/>
							</div>
						</div>
					</Col>
				</Row>
			</Fragment>
		);
	}
}

export default AccountsTab;
